import { toast } from 'react-toastify';
import FileUploadAPI from '../FileUploadAPI';

export const FileDownload = (url, fileName) => {
  return new Promise((resolve, reject) => {
    if (!url) {
      toast.error("Download URL not available");
      reject(new Error("Download URL not available"));
      return;
    }

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName || "download");
    document.body.appendChild(link);
    link.click();
    link.remove();
    resolve();
  });
}; 